export enum CostLicenseType {
  Development = 1,
  Production = 2,
}
